export const IS_WHATSAPP_ENABLED =
  process.env.NEXT_PUBLIC_IS_WHATSAPP_ENABLED === 'true'

export const IS_CELEBRATORY_WALLETS_ENABLED =
  process.env.NEXT_PUBLIC_IS_CELEBRATORY_WALLETS_ENABLED === 'true'

export const IS_SWILE_MAIS_INVOICES_ENABLED =
  process.env.NEXT_PUBLIC_IS_SWILE_MAIS_INVOICES_ENABLED === 'true'

export const FORCE_SBS_MODULES =
  process.env.NEXT_PUBLIC_FORCE_SBS_MODULES === 'true'

export const FORCE_RECARDING_MODULES =
  process.env.NEXT_PUBLIC_FORCE_RECARDING_MODULES === 'true'

export const IS_RECARDING_PREFERENCE_SURVEY_ENABLED =
  process.env.NEXT_PUBLIC_IS_RECARDING_PREFERENCE_SURVEY_ENABLED === 'true'

export const IS_QUALTRICS_ENABLED =
  process.env.NEXT_PUBLIC_IS_QUALTRICS_ENABLED === 'true'

// Kill switch to take QR Code Swile (PIX) payment temporarily out of the air.
// Defaults to enabled; set NEXT_PUBLIC_IS_QR_CODE_PAYMENT_DISABLED=true to disable.
export const IS_QR_CODE_PAYMENT_DISABLED =
  process.env.NEXT_PUBLIC_IS_QR_CODE_PAYMENT_DISABLED === 'true'

// Date (ISO 8601, with offset) from which exported files mask personal data
// (LGPD), e.g. 2026-11-09T00:00:00-03:00. Unset or invalid keeps masking off,
// like Multiaccess' FF_MASK_SENSITIVE_DATA.
export const MASK_SENSITIVE_DATA_STARTS_AT =
  process.env.NEXT_PUBLIC_FF_MASK_SENSITIVE_DATA_STARTS_AT ?? ''
